module.exports = __webpack_public_path__ + "af33d06c7157878b453218a68a70a659.png";